module.exports = __webpack_public_path__ + "img/img-user-demo.3a35004f.png";